/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { QuotaOptimizationConfig } from './QuotaOptimizationConfig';
import {
    QuotaOptimizationConfigFromJSON,
    QuotaOptimizationConfigFromJSONTyped,
    QuotaOptimizationConfigToJSON,
} from './QuotaOptimizationConfig';

/**
 * Per-object subscribe options that only apply to certain providers. Each option documents which providers support it; setting one for a provider that does not support it is rejected. Options that apply to the whole subscription live on `subscribe.providerOptions` instead.
 * @export
 * @interface SubscribeProviderOptions
 */
export interface SubscribeProviderOptions {
    /**
     * 
     * @type {QuotaOptimizationConfig}
     * @memberof SubscribeProviderOptions
     */
    quotaOptimization?: QuotaOptimizationConfig;
}

/**
 * Check if a given object implements the SubscribeProviderOptions interface.
 */
export function instanceOfSubscribeProviderOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscribeProviderOptionsFromJSON(json: any): SubscribeProviderOptions {
    return SubscribeProviderOptionsFromJSONTyped(json, false);
}

export function SubscribeProviderOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribeProviderOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quotaOptimization': !exists(json, 'quotaOptimization') ? undefined : QuotaOptimizationConfigFromJSON(json['quotaOptimization']),
    };
}

export function SubscribeProviderOptionsToJSON(value?: SubscribeProviderOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quotaOptimization': QuotaOptimizationConfigToJSON(value.quotaOptimization),
    };
}

